export const categories = [
  {
    Category: '02',
    SubCategory: '001',
    CategoryName: 'Cheese',
  },
  {
    Category: '02',
    SubCategory: '004',
    CategoryName: 'Tofu',
  },
  {
    Category: '03',
    SubCategory: '005',
    CategoryName: 'Eggs',
  },
  {
    Category: '05',
    SubCategory: '001',
    CategoryName: 'Whole Grain',
  },
  {
    Category: '05',
    SubCategory: '002',
    CategoryName: 'Non-Whole Grain',
  },
  {
    Category: '06',
    SubCategory: '000',
    CategoryName: 'Dry Beans or Peanut Butter',
  },
  {
    Category: '06',
    SubCategory: '001',
    CategoryName: 'Peanut Butter',
  },
  {
    Category: '06',
    SubCategory: '002',
    CategoryName: 'Dry Legumes - Beans',
  },
  {
    Category: '06',
    SubCategory: '003',
    CategoryName: 'Canned Beans',
  },
  {
    Category: '08',
    SubCategory: '001',
    CategoryName: 'Chunk Light Tuna',
  },
  {
    Category: '08',
    SubCategory: '002',
    CategoryName: 'Pink Salmon',
  },
  {
    Category: '08',
    SubCategory: '003',
    CategoryName: 'Sardines',
  },
  {
    Category: '08',
    SubCategory: '004',
    CategoryName: 'Mackerel',
  },
  {
    Category: '09',
    SubCategory: '001',
    CategoryName: 'Infant Cereal',
  },
  {
    Category: '12',
    SubCategory: '001',
    CategoryName: 'Infant Fruits',
  },
  {
    Category: '12',
    SubCategory: '002',
    CategoryName: 'Infant Vegetables',
  },
  {
    Category: '12',
    SubCategory: '003',
    CategoryName: 'Infant Fruits & Vegetables Combinations',
  },
  {
    Category: '12',
    SubCategory: '101',
    CategoryName: 'Infant Fruits-ORGANIC',
  },
  {
    Category: '12',
    SubCategory: '102',
    CategoryName: 'Infant Vegetables-ORGANIC',
  },
  {
    Category: '12',
    SubCategory: '103',
    CategoryName: 'Infant Fruits & Vegetables Combo-ORGANIC',
  },
  {
    Category: '13',
    SubCategory: '001',
    CategoryName: 'Infant Meats',
  },
  {
    Category: '13',
    SubCategory: '101',
    CategoryName: 'Infant Meats-ORGANIC',
  },
  {
    Category: '19',
    SubCategory: '001',
    CategoryName: 'Fresh Fruits & Vegetables CVB',
  },
  {
    Category: '19',
    SubCategory: '002',
    CategoryName: 'Frozen Fruits & Vegetables CVB',
  },
  {
    Category: '19',
    SubCategory: '003',
    CategoryName: 'Canned Fruits & Vegetables CVB',
  },
  {
    Category: '19',
    SubCategory: '004',
    CategoryName: 'Dried Fruits CVB',
  },
  {
    Category: '21',
    SubCategory: '010',
    CategoryName: 'Enfamil ProSobee Powder 12.9 oz',
  },
  {
    Category: '21',
    SubCategory: '011',
    CategoryName: 'Enfamil ProSobee Concentrate 13 oz',
  },
  {
    Category: '21',
    SubCategory: '013',
    CategoryName: 'Enfamil AR Powder 12.9 oz',
  },
  {
    Category: '21',
    SubCategory: '018',
    CategoryName: 'Enfamil Gentlease Powder 12.4 oz',
  },
  {
    Category: '21',
    SubCategory: '096',
    CategoryName: 'Enfamil Infant Powder 12.5 oz',
  },
  {
    Category: '21',
    SubCategory: '100',
    CategoryName: 'Enfamil Infant Concentrate 13 oz',
  },
  {
    Category: '21',
    SubCategory: '101',
    CategoryName: 'Enfamil Reguline Powder 12.4 oz',
  },
  {
    Category: '31',
    SubCategory: '002',
    CategoryName: 'Nutramigen Concentrate 13 fl oz',
  },
  {
    Category: '31',
    SubCategory: '011',
    CategoryName: 'Enfamil NeuroPro EnfaCare Powder 12.8 oz',
  },
  {
    Category: '31',
    SubCategory: '029',
    CategoryName: 'Similac Neosure Powder 13.1 oz',
  },
  {
    Category: '31',
    SubCategory: '070',
    CategoryName: 'Nutramigen Enflora LGG Powder 12.6 oz',
  },
  {
    Category: '31',
    SubCategory: '081',
    CategoryName: 'Similac Alimentum Powder 12.1 oz',
  },
  {
    Category: '41',
    SubCategory: '036',
    CategoryName: 'Similac Pediasure Vanilla RTF 8 oz',
  },
  {
    Category: '50',
    SubCategory: '001',
    CategoryName: 'Yogurt - Whole Milk',
  },
  {
    Category: '50',
    SubCategory: '002',
    CategoryName: 'Yogurt - Lowfat/Nonfat',
  },
  {
    Category: '51',
    SubCategory: '001',
    CategoryName: 'Whole Milk',
  },
  {
    Category: '51',
    SubCategory: '003',
    CategoryName: 'Lactose-Free Whole Milk',
  },
  {
    Category: '51',
    SubCategory: '011',
    CategoryName: 'Evaporated Whole Milk - Concentrated Liquid',
  },
  {
    Category: '52',
    SubCategory: '002',
    CategoryName: '"Nonfat and Lowfat',
  },
  {
    Category: '52',
    SubCategory: '004',
    CategoryName: 'Reduced Fat Milk (2% Fat)',
  },
  {
    Category: '52',
    SubCategory: '006',
    CategoryName: 'Lactose Free Milk - Lower Fat (Skim & 1%)',
  },
  {
    Category: '52',
    SubCategory: '011',
    CategoryName: 'Soy-Based Beverage',
  },
  {
    Category: '55',
    SubCategory: '001',
    CategoryName: 'Soy Milk',
  },
  {
    Category: '55',
    SubCategory: '002',
    CategoryName: 'Oat Milk',
  },
  {
    Category: '55',
    SubCategory: '003',
    CategoryName: 'Nut Milk',
  },
  {
    Category: '55',
    SubCategory: '004',
    CategoryName: 'Seed Milk',
  },
  {
    Category: '55',
    SubCategory: '005',
    CategoryName: 'Coconut Milk',
  },
  {
    Category: '55',
    SubCategory: '006',
    CategoryName: 'Rice Milk',
  },
  {
    Category: '55',
    SubCategory: '007',
    CategoryName: 'Pea Milk',
  },
  {
    Category: '55',
    SubCategory: '008',
    CategoryName: 'Oat Milk Blend',
  },
  {
    Category: '52',
    SubCategory: '012',
    CategoryName: 'Dry Milk (Powdered) - Lower Fat (Skim & 1%)',
  },
  {
    Category: '52',
    SubCategory: '014',
    CategoryName: 'Evaporated Milk (Concentrated Liquid) - Lower Fat',
  },
  {
    Category: '54',
    SubCategory: '001',
    CategoryName: 'Juice Concentrate 16 oz',
  },
  {
    Category: '54',
    SubCategory: '002',
    CategoryName: 'Juice Bottled 64 oz',
  },
  {
    Category: '54',
    SubCategory: '101',
    CategoryName: 'Juice Concentrate 11.5 or 12 oz',
  },
]

export const NOT_SUBMITTED_STATUS = 0
export const SUBMITTED_STATUS = 1
export const IN_REVIEW_STATUS = 2
export const APPROVED_STATUS = 3
export const REJECTED_STATUS = 4
